import { render, staticRenderFns } from "./PrintableObjective.vue?vue&type=template&id=363ef052&scoped=true"
import script from "./PrintableObjective.vue?vue&type=script&lang=js"
export * from "./PrintableObjective.vue?vue&type=script&lang=js"
import style0 from "./PrintableObjective.vue?vue&type=style&index=0&id=363ef052&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363ef052",
  null
  
)

export default component.exports